import { render, staticRenderFns } from "./ComiteHonor.vue?vue&type=template&id=336292c9&"
import script from "./ComiteHonor.vue?vue&type=script&lang=js&"
export * from "./ComiteHonor.vue?vue&type=script&lang=js&"
import style0 from "./ComiteHonor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports